import { type ShipmentTag } from 'core/shipment-tag/domain/ShipmentTag'
import { mapApiToTags, type RawShipmentTag } from 'core/shipment-tag/infra/ShipmentTagsMapper'

/** API payload for `shipment` on spot-quote responses. */
export type RawSpotQuoteApiShipment = {
  uuid: string
  carrier_1xp_link: string
  tags?: Array<RawShipmentTag> | null
}

export function mapSpotQuoteShipmentFromApi(raw?: RawSpotQuoteApiShipment | null):
  | {
      uuid: string
      shipmentDetailsLink: string
      tags?: Array<ShipmentTag>
    }
  | undefined {
  if (!raw) return undefined

  return {
    uuid: raw.uuid,
    shipmentDetailsLink: raw.carrier_1xp_link,
    tags: mapApiToTags(raw.tags),
  }
}
